import React from 'react';
import Form from "react-bootstrap/Form";

const PasswordForm = ({fields, handleFieldChange, passwordMismatchMessage, emailMismatchMessage, messages, hasEmail}) => {
  return (
    <>
      <h3>ログイン情報</h3>
      <ol className="passwordPolicy">
        <li>パスワードに使用できる文字は、半角の英字すべて・半角の数字すべてです。</li>
        <li>パスワードには、英字・数字それぞれを最低1文字ずつ含む必要があります。</li>
        <li>パスワードの長さは、半角8文字以上から半角30文字以下です。</li>
        <li>変更前のパスワードと同じパスワードは設定できません。</li>
        </ol>
      <dl>
        <dt>ログインID（会員番号）</dt>
        <dd>
          { fields.loginId }&nbsp;
        </dd>

        <dt>パスワード<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="password" size="lg">
            <Form.Control
              type="text"
              name="password"
              value={fields.password}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="passwordMessage" className="errorMessages">{messages.password.n}</p>
        </dd>
        <dt>パスワード（確認用）<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="passwordConfirmation" size="lg">
            <Form.Control
              type="text"
              name="passwordConfirmation"
              value={fields.passwordConfirmation}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="passwordConfirmationMessage" className="errorMessages">{messages.passwordConfirmation.n}</p>
          <p id="passwordMismatchMessage" className="errorMessages">{ passwordMismatchMessage }</p>
        </dd>
        <dt className={ hasEmail ? "hideInputRow" : "" }>Email<span className="red">*</span></dt>
        <dd className={ hasEmail ? "hideInputRow" : "" }>
          <Form.Group controlId="affiliationEmail" size="lg">
            <Form.Control
              type="text"
              name="affiliationEmail"
              value={fields.affiliationEmail}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationEmailMessage" className="errorMessages">{messages.affiliationEmail.n}</p>
        </dd>

        <dt className={ hasEmail ? "hideInputRow" : "" }>Email（確認用）<span className="red">*</span></dt>
        <dd className={ hasEmail ? "hideInputRow" : "" }>
          <Form.Group controlId="affiliationEmailConfirmation" size="lg">
            <Form.Control
              type="text"
              name="affiliationEmailConfirmation"
              value={fields.affiliationEmailConfirmation}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationEmailConfirmationMessage" className="errorMessages">{messages.affiliationEmailConfirmation.n}</p>
          <p id="emailMismatchMessage" className="errorMessages">{ emailMismatchMessage }</p>
        </dd>

      </dl>
    </>
  );
}

export default PasswordForm;
